import React, {useState} from 'react'
function returnInitialState(storageKey, initialValue) {
    try {
      // Get from local storage by key
      const item = window.sessionStorage.getItem(storageKey);
      // Parse stored json or if none return an empty object
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return an empty object
      console.log(error);
      return initialValue;
    }
  }
  
  export function useSessionStorage(storageKey, initialValue) {
    const [storedValue, setStoredValue] = useState(
      returnInitialState(storageKey, initialValue)
    );
    
    const setValue = (value) => {
      try {
      // Allow value to be a function so we have same API as useState
        const valueToStore =
        value instanceof Function ? value(storedValue) : value;
        // Save to local storage
        window.sessionStorage.setItem(storageKey, JSON.stringify(valueToStore));
        // Save state
        setStoredValue(valueToStore);
      } catch (error) {
        // A more advanced implementation would handle the error case
        console.log(error);
      }
    };
    
    return [storedValue, setValue]
  }